// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"t3-z","colorTextValue":"u3-z","swatches":"v3-z","collapseLink":"w3-z","isCollapsed":"x3-z","dropdown":"y3-z","disabled":"z3-z"};